import { defineStore } from 'pinia';
import {
    COLORLAYER_TARGET_STATES_NEW,
    ColorLayerTargetState,
    COLORMODULE_POSSIBLE_STATES
} from "@km/components/color/ModuleColorAnimationStates";
import {CLOSED} from "@km/animations/animationFactory";

function getNewColorlayerOpenStack(colorLayerOpenStack:COLORMODULE_POSSIBLE_STATES[], newState):COLORMODULE_POSSIBLE_STATES[] {
    const STATES_ON_SAME_LEVEL = [COLORMODULE_POSSIBLE_STATES.patterncategories, COLORMODULE_POSSIBLE_STATES.individualColorSelection];
    if(newState === COLORMODULE_POSSIBLE_STATES.closed) {
        return [];
    }
    if(colorLayerOpenStack.length === 0) {
        colorLayerOpenStack.push(newState);
        return colorLayerOpenStack
    }
    if(STATES_ON_SAME_LEVEL.indexOf(colorLayerOpenStack[colorLayerOpenStack.length-1])>-1 && STATES_ON_SAME_LEVEL.indexOf(newState)>-1) {
        colorLayerOpenStack.pop();
        return getNewColorlayerOpenStack(colorLayerOpenStack, newState);
    }
    if(colorLayerOpenStack[colorLayerOpenStack.length-1] !== newState) {
        colorLayerOpenStack.push(newState);
        return colorLayerOpenStack
    }

    return colorLayerOpenStack
}

export const useModuleColorOpenStateStore = defineStore('moduleColorOpenState', {
    state: () => ({
        currentState: COLORMODULE_POSSIBLE_STATES.closed,
        componentTargetStates: {
            areaColorGroupSelection: CLOSED,
            areaOutlinePatternSelection: CLOSED,
            areaOutlinePatternSelectListModules: CLOSED,
            shadeGroupSelection: CLOSED,
            shade: CLOSED,
            buttons: CLOSED,
            patternCategories: CLOSED,
            patternSelection: CLOSED,
            patternColorSelection: CLOSED,
            patternColorShadeGroupSelection: CLOSED,
            patternColorShadeSelection: CLOSED,
            patternFarbvorschlaege: CLOSED
        } as ColorLayerTargetState,
        colorLayerOpenStack: [] as COLORMODULE_POSSIBLE_STATES[]
    }),

    getters: {
        getCurrentState: (state) => state.currentState,
        getAreaColorGroupSelection: (state) => state.componentTargetStates.areaColorGroupSelection,
        getAreaOutlinePatternState: (state) => state.componentTargetStates.areaOutlinePatternSelection,
        getAreaOutlinePatternButtonState: (state) => state.componentTargetStates.areaOutlinePatternSelectListModules,
        getShadeGroupState: (state) => state.componentTargetStates.shadeGroupSelection,
        getShadeState: (state) => state.componentTargetStates.shade,
        getButtonsState: (state) => state.componentTargetStates.buttons,
        getPatternCategoriesState: (state) => state.componentTargetStates.patternCategories,
        getPatternState: (state) => state.componentTargetStates.patternSelection,
        getPatternColorState: (state) => state.componentTargetStates.patternColorSelection,
        getPatternColorShadeGroupSelection: (state) => state.componentTargetStates.patternColorShadeGroupSelection,
        getPatternColorShadeSelection: (state) => state.componentTargetStates.patternColorShadeSelection,
        getPatternFarbVorschlaegeState: (state) => state.componentTargetStates.patternFarbvorschlaege,
        getTopOfOpenStack: (state) => state.colorLayerOpenStack[state.colorLayerOpenStack.length-1] || COLORMODULE_POSSIBLE_STATES.closed
    },

    actions: {
        setCurrentState(newstate: COLORMODULE_POSSIBLE_STATES) {
            this.colorLayerOpenStack = getNewColorlayerOpenStack([...this.colorLayerOpenStack], newstate);
            const targetState = COLORLAYER_TARGET_STATES_NEW[newstate];

            this.componentTargetStates.areaColorGroupSelection = targetState.areaColorGroupSelection;
            this.componentTargetStates.areaOutlinePatternSelection = targetState.areaOutlinePatternSelection;
            this.componentTargetStates.areaOutlinePatternSelectListModules = targetState.areaOutlinePatternSelectListModules;
            this.componentTargetStates.shadeGroupSelection = targetState.shadeGroupSelection;
            this.componentTargetStates.shade = targetState.shade;
            this.componentTargetStates.buttons = targetState.buttons;
            this.componentTargetStates.patternCategories = targetState.patternCategories;
            this.componentTargetStates.patternSelection = targetState.patternSelection;
            this.componentTargetStates.patternColorSelection = targetState.patternColorSelection;
            this.componentTargetStates.patternColorShadeGroupSelection = targetState.patternColorShadeGroupSelection;
            this.componentTargetStates.patternColorShadeSelection = targetState.patternColorShadeSelection;
            this.componentTargetStates.patternFarbvorschlaege = targetState.patternFarbvorschlaege;

            this.currentState = newstate;
        },
        ensureStateIsNotClosed:function() {
            if (this.getCurrentState === COLORMODULE_POSSIBLE_STATES.closed) {
                this.setCurrentState(COLORMODULE_POSSIBLE_STATES.areaColorGroupSelection)
            }
        },
        goBackOneLevel: function(){
            this.colorLayerOpenStack.pop();
            this.setCurrentState(this.getTopOfOpenStack);
        }
    }
});